export default "__VITE_ASSET__DZxk1LHZ__"